<div class="container">
  <h1 class="page-title">
    <span class="icon"><i class="fas fa-money-bill-transfer"></i></span>{{ 'Menu.Menu.ExchangeRate' | translate }}
  </h1>
  <p-card>
    <form class="detail-form" [formGroup]="editForm">
      <div class="field grid">
        <div class="p-fluid field grid">
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ExchangeRate.MainTable.ExchangeType' | translate }}</label>
            <div class="col-8 column-value">
              {{
                dailyRate?.rateType
                  | optionsMapping: rateTypeOptions
                  | replaceNullWith: "-"
              }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ExchangeRate.MainTable.ExchangeDate' | translate }}</label>
            <div class="col-8 column-value">
              {{
                dailyRate?.date
                  | date: "yyyy-MM-dd":this.laasSetting.facilityTimeZone
                  | replaceNullWith: "-"
              }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ExchangeRate.MainTable.OriginExchangeRate' | translate }}</label>
            <div class="col-8 column-value">
              {{
                dailyRate?.fromCurrency
                  | optionsMapping: currencyOptions
                  | replaceNullWith: "-"
              }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ExchangeRate.MainTable.ConversionRate' | translate }}</label>
            <div class="col-8 column-value">
              {{
                dailyRate?.toCurrency
                  | optionsMapping: currencyOptions
                  | replaceNullWith: "-"
              }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ExchangeRate.MainTable.ExchangeRate' | translate }}</label>
            <div class="col-8 column-value">
              <p-inputNumber
                formControlName="rate"
                [(ngModel)]="dailyRate.rate"
                mode="decimal"
                [minFractionDigits]="5"
                [maxFractionDigits]="5"
                [maxlength]="15"
              ></p-inputNumber>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ExchangeRate.MainTable.ExchangeRateRange' | translate }}</label>
            <div class="col-8 column-value">
              {{ dailyRate?.rateYM | replaceNullWith: "-" }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ExchangeRate.MainTable.IsValid' | translate }}</label>
            <div class="col-8 column-value">
              <p-radioButton
                formControlName="isActivated"
                name="isActivated"
                value="1"
                label="Y"
                [(ngModel)]="dailyRate.isActivated"
              ></p-radioButton>
              <p-radioButton
                formControlName="isActivated"
                name="isActivated"
                value="0"
                label="N"
                [(ngModel)]="dailyRate.isActivated"
                class="ml-2"
              ></p-radioButton>
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ExchangeRate.MainTable.Creator' | translate }}</label>
            <div class="col-8 column-value">
              {{ dailyRate?.createUser | replaceNullWith: "-" }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ExchangeRate.MainTable.CreationTime' | translate }}</label>
            <div class="col-8 column-value">
              {{
                dailyRate?.createDt
                  | date
                    : "yyyy-MM-dd HH:mm:ss"
                    : this.laasSetting.facilityTimeZone
                  | replaceNullWith: "-"
              }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ExchangeRate.MainTable.UpdateBy' | translate }}</label>
            <div class="col-8 column-value">
              {{ dailyRate?.updateUser | replaceNullWith: "-" }}
            </div>
          </div>
          <div class="field grid col-6 align-items-baseline">
            <label class="col-4 column-label">{{ 'ExchangeRate.MainTable.UpdateTime' | translate }}</label>
            <div class="col-8 column-value">
              {{
                dailyRate?.updateDt
                  | date
                    : "yyyy-MM-dd HH:mm:ss"
                    : this.laasSetting.facilityTimeZone
                  | replaceNullWith: "-"
              }}
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="col">
            <button
              pButton
              pRipple
              label="{{ 'Common.Button.Save' | translate }}"
              (click)="saveBtnClick($event)"
              class="mr-2"
            ></button>
            <button
              pButton
              pRipple
              label="{{ 'Common.Button.ReturnWithoutSaving' | translate }}"
              (click)="goToLastPage()"
              class="mr-2"
            ></button>
          </div>
        </div>
      </div>
    </form>
  </p-card>
</div>
